import React from 'react';


function VideoPlayer({base64String, extension}) {

    let audioDataUri;
    let type;

    switch (extension) {
        case 'mp4':
            audioDataUri = `data:video/mp4;base64,${base64String}`;
            type = 'video/mp4';
            break;
        case 'avi':
            audioDataUri = `data:video/avi;base64,${base64String}`;
            type = 'video/avi';
            break;
        default:
            audioDataUri = `data:video/avi;base64,${base64String}`;
            type = 'video/avi';
            break;
    }

    return (
        <video
            controls
            style={{
                maxWidth: '100%'
            }}
        >
            <source
                src={audioDataUri}
                type={type}
            />
            Your browser does not support the video element.
        </video>
    );
}

export default VideoPlayer;